module.exports = __webpack_public_path__ + "media/images/emblems/Montfaucon-150995876eaf08684df794ec220f5563.png";